/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUserProfile = /* GraphQL */ `mutation CreateUserProfile(
  $input: CreateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  createUserProfile(input: $input, condition: $condition) {
    id
    email
    name
    image
    authProviderUserId
    preferences
    createdAt
    updatedAt
    deactivatedAt
    onboardingState
    is_subscribed
    credits
    credits_quota
    meeting_hours
    meeting_hours_quota
    scheduled_hours
    timezone
    language
    autoScheduleProxy
    notifications {
      liveActivity
      pmfSummary
      preBrief
      __typename
    }
    preBrief
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserProfileMutationVariables,
  APITypes.CreateUserProfileMutation
>;
export const updateUserProfile = /* GraphQL */ `mutation UpdateUserProfile(
  $input: UpdateUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  updateUserProfile(input: $input, condition: $condition) {
    id
    email
    name
    image
    authProviderUserId
    preferences
    createdAt
    updatedAt
    deactivatedAt
    onboardingState
    is_subscribed
    credits
    credits_quota
    meeting_hours
    meeting_hours_quota
    scheduled_hours
    timezone
    language
    autoScheduleProxy
    notifications {
      liveActivity
      pmfSummary
      preBrief
      __typename
    }
    preBrief
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserProfileMutationVariables,
  APITypes.UpdateUserProfileMutation
>;
export const deleteUserProfile = /* GraphQL */ `mutation DeleteUserProfile(
  $input: DeleteUserProfileInput!
  $condition: ModelUserProfileConditionInput
) {
  deleteUserProfile(input: $input, condition: $condition) {
    id
    email
    name
    image
    authProviderUserId
    preferences
    createdAt
    updatedAt
    deactivatedAt
    onboardingState
    is_subscribed
    credits
    credits_quota
    meeting_hours
    meeting_hours_quota
    scheduled_hours
    timezone
    language
    autoScheduleProxy
    notifications {
      liveActivity
      pmfSummary
      preBrief
      __typename
    }
    preBrief
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserProfileMutationVariables,
  APITypes.DeleteUserProfileMutation
>;
export const createProxy = /* GraphQL */ `mutation CreateProxy(
  $input: CreateProxyInput!
  $condition: ModelProxyConditionInput
) {
  createProxy(input: $input, condition: $condition) {
    id
    userProfileId
    name
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProxyMutationVariables,
  APITypes.CreateProxyMutation
>;
export const updateProxy = /* GraphQL */ `mutation UpdateProxy(
  $input: UpdateProxyInput!
  $condition: ModelProxyConditionInput
) {
  updateProxy(input: $input, condition: $condition) {
    id
    userProfileId
    name
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProxyMutationVariables,
  APITypes.UpdateProxyMutation
>;
export const deleteProxy = /* GraphQL */ `mutation DeleteProxy(
  $input: DeleteProxyInput!
  $condition: ModelProxyConditionInput
) {
  deleteProxy(input: $input, condition: $condition) {
    id
    userProfileId
    name
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProxyMutationVariables,
  APITypes.DeleteProxyMutation
>;
export const createPlugin = /* GraphQL */ `mutation CreatePlugin(
  $input: CreatePluginInput!
  $condition: ModelPluginConditionInput
) {
  createPlugin(input: $input, condition: $condition) {
    id
    authProviderUserId
    userProfileId
    pluginType
    enabled
    pluginUserId
    calendars
    createdAt
    updatedAt
    config
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePluginMutationVariables,
  APITypes.CreatePluginMutation
>;
export const updatePlugin = /* GraphQL */ `mutation UpdatePlugin(
  $input: UpdatePluginInput!
  $condition: ModelPluginConditionInput
) {
  updatePlugin(input: $input, condition: $condition) {
    id
    authProviderUserId
    userProfileId
    pluginType
    enabled
    pluginUserId
    calendars
    createdAt
    updatedAt
    config
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePluginMutationVariables,
  APITypes.UpdatePluginMutation
>;
export const deletePlugin = /* GraphQL */ `mutation DeletePlugin(
  $input: DeletePluginInput!
  $condition: ModelPluginConditionInput
) {
  deletePlugin(input: $input, condition: $condition) {
    id
    authProviderUserId
    userProfileId
    pluginType
    enabled
    pluginUserId
    calendars
    createdAt
    updatedAt
    config
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePluginMutationVariables,
  APITypes.DeletePluginMutation
>;
export const createDeviceToken = /* GraphQL */ `mutation CreateDeviceToken(
  $input: CreateDeviceTokenInput!
  $condition: ModelDeviceTokenConditionInput
) {
  createDeviceToken(input: $input, condition: $condition) {
    id
    userProfileId
    authProviderUserId
    token
    platform
    deviceId
    deviceModelName
    deviceSystemVersion
    createdAt
    updatedAt
    lastUsedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDeviceTokenMutationVariables,
  APITypes.CreateDeviceTokenMutation
>;
export const updateDeviceToken = /* GraphQL */ `mutation UpdateDeviceToken(
  $input: UpdateDeviceTokenInput!
  $condition: ModelDeviceTokenConditionInput
) {
  updateDeviceToken(input: $input, condition: $condition) {
    id
    userProfileId
    authProviderUserId
    token
    platform
    deviceId
    deviceModelName
    deviceSystemVersion
    createdAt
    updatedAt
    lastUsedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDeviceTokenMutationVariables,
  APITypes.UpdateDeviceTokenMutation
>;
export const deleteDeviceToken = /* GraphQL */ `mutation DeleteDeviceToken(
  $input: DeleteDeviceTokenInput!
  $condition: ModelDeviceTokenConditionInput
) {
  deleteDeviceToken(input: $input, condition: $condition) {
    id
    userProfileId
    authProviderUserId
    token
    platform
    deviceId
    deviceModelName
    deviceSystemVersion
    createdAt
    updatedAt
    lastUsedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDeviceTokenMutationVariables,
  APITypes.DeleteDeviceTokenMutation
>;
export const createMeeting = /* GraphQL */ `mutation CreateMeeting(
  $input: CreateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  createMeeting(input: $input, condition: $condition) {
    id
    botId
    startTimeUtc
    endTimeUtc
    deduplicationKey
    meetingRawData
    proxyMeetingIds
    fullTranscription
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMeetingMutationVariables,
  APITypes.CreateMeetingMutation
>;
export const updateMeeting = /* GraphQL */ `mutation UpdateMeeting(
  $input: UpdateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  updateMeeting(input: $input, condition: $condition) {
    id
    botId
    startTimeUtc
    endTimeUtc
    deduplicationKey
    meetingRawData
    proxyMeetingIds
    fullTranscription
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMeetingMutationVariables,
  APITypes.UpdateMeetingMutation
>;
export const deleteMeeting = /* GraphQL */ `mutation DeleteMeeting(
  $input: DeleteMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  deleteMeeting(input: $input, condition: $condition) {
    id
    botId
    startTimeUtc
    endTimeUtc
    deduplicationKey
    meetingRawData
    proxyMeetingIds
    fullTranscription
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMeetingMutationVariables,
  APITypes.DeleteMeetingMutation
>;
export const createProxyMeeting = /* GraphQL */ `mutation CreateProxyMeeting(
  $input: CreateProxyMeetingInput!
  $condition: ModelProxyMeetingConditionInput
) {
  createProxyMeeting(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    botId
    calendarEventId
    calendarEventICalUID
    calendarId
    projectIds
    startTimeUtc
    endTimeUtc
    meetingUrl
    deduplicationKey
    meetingRawData
    platform
    summaries
    themes
    observations
    status
    transcription {
      rawTranscript
      __typename
    }
    memories
    sessionUID
    userPreBrief
    chatSessionId
    aiSuggestions
    insights {
      id
      label
      type
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProxyMeetingMutationVariables,
  APITypes.CreateProxyMeetingMutation
>;
export const updateProxyMeeting = /* GraphQL */ `mutation UpdateProxyMeeting(
  $input: UpdateProxyMeetingInput!
  $condition: ModelProxyMeetingConditionInput
) {
  updateProxyMeeting(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    botId
    calendarEventId
    calendarEventICalUID
    calendarId
    projectIds
    startTimeUtc
    endTimeUtc
    meetingUrl
    deduplicationKey
    meetingRawData
    platform
    summaries
    themes
    observations
    status
    transcription {
      rawTranscript
      __typename
    }
    memories
    sessionUID
    userPreBrief
    chatSessionId
    aiSuggestions
    insights {
      id
      label
      type
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProxyMeetingMutationVariables,
  APITypes.UpdateProxyMeetingMutation
>;
export const deleteProxyMeeting = /* GraphQL */ `mutation DeleteProxyMeeting(
  $input: DeleteProxyMeetingInput!
  $condition: ModelProxyMeetingConditionInput
) {
  deleteProxyMeeting(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    botId
    calendarEventId
    calendarEventICalUID
    calendarId
    projectIds
    startTimeUtc
    endTimeUtc
    meetingUrl
    deduplicationKey
    meetingRawData
    platform
    summaries
    themes
    observations
    status
    transcription {
      rawTranscript
      __typename
    }
    memories
    sessionUID
    userPreBrief
    chatSessionId
    aiSuggestions
    insights {
      id
      label
      type
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProxyMeetingMutationVariables,
  APITypes.DeleteProxyMeetingMutation
>;
export const createCalendarEvent = /* GraphQL */ `mutation CreateCalendarEvent(
  $input: CreateCalendarEventInput!
  $condition: ModelCalendarEventConditionInput
) {
  createCalendarEvent(input: $input, condition: $condition) {
    id
    uuid
    calendarId
    userProfileId
    platform
    proxyMeetingId
    proxyMeeting {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    dateUtc
    projectIds
    recurringId
    iCalUid
    title
    botStatus {
      message
      statusCode
      subCode
      __typename
    }
    startTimeUtc
    endTimeUtc
    isCancelled
    shortDescription
    meetingUrl
    organizerEmail
    fullDescription
    responseStatus
    status
    descriptionContentType
    attendees
    platformSpecificData
    metadata
    preBriefState
    preBrief {
      id
      label
      type
      content
      __typename
    }
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCalendarEventMutationVariables,
  APITypes.CreateCalendarEventMutation
>;
export const updateCalendarEvent = /* GraphQL */ `mutation UpdateCalendarEvent(
  $input: UpdateCalendarEventInput!
  $condition: ModelCalendarEventConditionInput
) {
  updateCalendarEvent(input: $input, condition: $condition) {
    id
    uuid
    calendarId
    userProfileId
    platform
    proxyMeetingId
    proxyMeeting {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    dateUtc
    projectIds
    recurringId
    iCalUid
    title
    botStatus {
      message
      statusCode
      subCode
      __typename
    }
    startTimeUtc
    endTimeUtc
    isCancelled
    shortDescription
    meetingUrl
    organizerEmail
    fullDescription
    responseStatus
    status
    descriptionContentType
    attendees
    platformSpecificData
    metadata
    preBriefState
    preBrief {
      id
      label
      type
      content
      __typename
    }
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCalendarEventMutationVariables,
  APITypes.UpdateCalendarEventMutation
>;
export const deleteCalendarEvent = /* GraphQL */ `mutation DeleteCalendarEvent(
  $input: DeleteCalendarEventInput!
  $condition: ModelCalendarEventConditionInput
) {
  deleteCalendarEvent(input: $input, condition: $condition) {
    id
    uuid
    calendarId
    userProfileId
    platform
    proxyMeetingId
    proxyMeeting {
      id
      userProfileId
      proxyId
      botId
      calendarEventId
      calendarEventICalUID
      calendarId
      projectIds
      startTimeUtc
      endTimeUtc
      meetingUrl
      deduplicationKey
      meetingRawData
      platform
      summaries
      themes
      observations
      status
      memories
      sessionUID
      userPreBrief
      chatSessionId
      aiSuggestions
      createdAt
      updatedAt
      __typename
    }
    dateUtc
    projectIds
    recurringId
    iCalUid
    title
    botStatus {
      message
      statusCode
      subCode
      __typename
    }
    startTimeUtc
    endTimeUtc
    isCancelled
    shortDescription
    meetingUrl
    organizerEmail
    fullDescription
    responseStatus
    status
    descriptionContentType
    attendees
    platformSpecificData
    metadata
    preBriefState
    preBrief {
      id
      label
      type
      content
      __typename
    }
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCalendarEventMutationVariables,
  APITypes.DeleteCalendarEventMutation
>;
export const createStream = /* GraphQL */ `mutation CreateStream(
  $input: CreateStreamInput!
  $condition: ModelStreamConditionInput
) {
  createStream(input: $input, condition: $condition) {
    id
    userProfileId
    pluginIds
    pluginMetadata
    name
    description
    aiTitle
    aiDescription
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStreamMutationVariables,
  APITypes.CreateStreamMutation
>;
export const updateStream = /* GraphQL */ `mutation UpdateStream(
  $input: UpdateStreamInput!
  $condition: ModelStreamConditionInput
) {
  updateStream(input: $input, condition: $condition) {
    id
    userProfileId
    pluginIds
    pluginMetadata
    name
    description
    aiTitle
    aiDescription
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStreamMutationVariables,
  APITypes.UpdateStreamMutation
>;
export const deleteStream = /* GraphQL */ `mutation DeleteStream(
  $input: DeleteStreamInput!
  $condition: ModelStreamConditionInput
) {
  deleteStream(input: $input, condition: $condition) {
    id
    userProfileId
    pluginIds
    pluginMetadata
    name
    description
    aiTitle
    aiDescription
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStreamMutationVariables,
  APITypes.DeleteStreamMutation
>;
export const createProject = /* GraphQL */ `mutation CreateProject(
  $input: CreateProjectInput!
  $condition: ModelProjectConditionInput
) {
  createProject(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    streamId
    stream {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    metadata
    name
    title
    aiTitle
    subtitle
    aiSubtitle
    description
    aiDescription
    aiCompletionCriteria
    userContext
    status
    state
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectMutationVariables,
  APITypes.CreateProjectMutation
>;
export const updateProject = /* GraphQL */ `mutation UpdateProject(
  $input: UpdateProjectInput!
  $condition: ModelProjectConditionInput
) {
  updateProject(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    streamId
    stream {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    metadata
    name
    title
    aiTitle
    subtitle
    aiSubtitle
    description
    aiDescription
    aiCompletionCriteria
    userContext
    status
    state
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectMutationVariables,
  APITypes.UpdateProjectMutation
>;
export const deleteProject = /* GraphQL */ `mutation DeleteProject(
  $input: DeleteProjectInput!
  $condition: ModelProjectConditionInput
) {
  deleteProject(input: $input, condition: $condition) {
    id
    userProfileId
    proxyId
    streamId
    stream {
      id
      userProfileId
      pluginIds
      pluginMetadata
      name
      description
      aiTitle
      aiDescription
      enabled
      color
      createdAt
      updatedAt
      __typename
    }
    metadata
    name
    title
    aiTitle
    subtitle
    aiSubtitle
    description
    aiDescription
    aiCompletionCriteria
    userContext
    status
    state
    enabled
    color
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectMutationVariables,
  APITypes.DeleteProjectMutation
>;
export const createDataAccess = /* GraphQL */ `mutation CreateDataAccess(
  $input: CreateDataAccessInput!
  $condition: ModelDataAccessConditionInput
) {
  createDataAccess(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    pluginId
    sourceIds
    type
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDataAccessMutationVariables,
  APITypes.CreateDataAccessMutation
>;
export const updateDataAccess = /* GraphQL */ `mutation UpdateDataAccess(
  $input: UpdateDataAccessInput!
  $condition: ModelDataAccessConditionInput
) {
  updateDataAccess(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    pluginId
    sourceIds
    type
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataAccessMutationVariables,
  APITypes.UpdateDataAccessMutation
>;
export const deleteDataAccess = /* GraphQL */ `mutation DeleteDataAccess(
  $input: DeleteDataAccessInput!
  $condition: ModelDataAccessConditionInput
) {
  deleteDataAccess(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    pluginId
    sourceIds
    type
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDataAccessMutationVariables,
  APITypes.DeleteDataAccessMutation
>;
export const createArtifact = /* GraphQL */ `mutation CreateArtifact(
  $input: CreateArtifactInput!
  $condition: ModelArtifactConditionInput
) {
  createArtifact(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    dataAccessId
    pluginId
    state
    pluginType
    name
    fileExtension
    s3Pointer
    aiContent
    aiReference
    aiReasoning
    sourceId
    aiMetadata
    enabled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateArtifactMutationVariables,
  APITypes.CreateArtifactMutation
>;
export const updateArtifact = /* GraphQL */ `mutation UpdateArtifact(
  $input: UpdateArtifactInput!
  $condition: ModelArtifactConditionInput
) {
  updateArtifact(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    dataAccessId
    pluginId
    state
    pluginType
    name
    fileExtension
    s3Pointer
    aiContent
    aiReference
    aiReasoning
    sourceId
    aiMetadata
    enabled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateArtifactMutationVariables,
  APITypes.UpdateArtifactMutation
>;
export const deleteArtifact = /* GraphQL */ `mutation DeleteArtifact(
  $input: DeleteArtifactInput!
  $condition: ModelArtifactConditionInput
) {
  deleteArtifact(input: $input, condition: $condition) {
    id
    userProfileId
    projectId
    dataAccessId
    pluginId
    state
    pluginType
    name
    fileExtension
    s3Pointer
    aiContent
    aiReference
    aiReasoning
    sourceId
    aiMetadata
    enabled
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteArtifactMutationVariables,
  APITypes.DeleteArtifactMutation
>;
export const createNote = /* GraphQL */ `mutation CreateNote(
  $input: CreateNoteInput!
  $condition: ModelNoteConditionInput
) {
  createNote(input: $input, condition: $condition) {
    id
    userProfileId
    relatedType
    relatedId
    content
    title
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoteMutationVariables,
  APITypes.CreateNoteMutation
>;
export const updateNote = /* GraphQL */ `mutation UpdateNote(
  $input: UpdateNoteInput!
  $condition: ModelNoteConditionInput
) {
  updateNote(input: $input, condition: $condition) {
    id
    userProfileId
    relatedType
    relatedId
    content
    title
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoteMutationVariables,
  APITypes.UpdateNoteMutation
>;
export const deleteNote = /* GraphQL */ `mutation DeleteNote(
  $input: DeleteNoteInput!
  $condition: ModelNoteConditionInput
) {
  deleteNote(input: $input, condition: $condition) {
    id
    userProfileId
    relatedType
    relatedId
    content
    title
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoteMutationVariables,
  APITypes.DeleteNoteMutation
>;
export const createConcept = /* GraphQL */ `mutation CreateConcept(
  $input: CreateConceptInput!
  $condition: ModelConceptConditionInput
) {
  createConcept(input: $input, condition: $condition) {
    id
    userProfileId
    title
    type
    entries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConceptMutationVariables,
  APITypes.CreateConceptMutation
>;
export const updateConcept = /* GraphQL */ `mutation UpdateConcept(
  $input: UpdateConceptInput!
  $condition: ModelConceptConditionInput
) {
  updateConcept(input: $input, condition: $condition) {
    id
    userProfileId
    title
    type
    entries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConceptMutationVariables,
  APITypes.UpdateConceptMutation
>;
export const deleteConcept = /* GraphQL */ `mutation DeleteConcept(
  $input: DeleteConceptInput!
  $condition: ModelConceptConditionInput
) {
  deleteConcept(input: $input, condition: $condition) {
    id
    userProfileId
    title
    type
    entries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConceptMutationVariables,
  APITypes.DeleteConceptMutation
>;
export const createConceptEntry = /* GraphQL */ `mutation CreateConceptEntry(
  $input: CreateConceptEntryInput!
  $condition: ModelConceptEntryConditionInput
) {
  createConceptEntry(input: $input, condition: $condition) {
    id
    userProfileId
    conceptId
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConceptEntryMutationVariables,
  APITypes.CreateConceptEntryMutation
>;
export const updateConceptEntry = /* GraphQL */ `mutation UpdateConceptEntry(
  $input: UpdateConceptEntryInput!
  $condition: ModelConceptEntryConditionInput
) {
  updateConceptEntry(input: $input, condition: $condition) {
    id
    userProfileId
    conceptId
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConceptEntryMutationVariables,
  APITypes.UpdateConceptEntryMutation
>;
export const deleteConceptEntry = /* GraphQL */ `mutation DeleteConceptEntry(
  $input: DeleteConceptEntryInput!
  $condition: ModelConceptEntryConditionInput
) {
  deleteConceptEntry(input: $input, condition: $condition) {
    id
    userProfileId
    conceptId
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConceptEntryMutationVariables,
  APITypes.DeleteConceptEntryMutation
>;
export const createContextQuestion = /* GraphQL */ `mutation CreateContextQuestion(
  $input: CreateContextQuestionInput!
  $condition: ModelContextQuestionConditionInput
) {
  createContextQuestion(input: $input, condition: $condition) {
    id
    userProfileId
    questionText
    questionType
    options
    readyForUser
    context
    answer
    answeredAt
    confidenceImpact
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContextQuestionMutationVariables,
  APITypes.CreateContextQuestionMutation
>;
export const updateContextQuestion = /* GraphQL */ `mutation UpdateContextQuestion(
  $input: UpdateContextQuestionInput!
  $condition: ModelContextQuestionConditionInput
) {
  updateContextQuestion(input: $input, condition: $condition) {
    id
    userProfileId
    questionText
    questionType
    options
    readyForUser
    context
    answer
    answeredAt
    confidenceImpact
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContextQuestionMutationVariables,
  APITypes.UpdateContextQuestionMutation
>;
export const deleteContextQuestion = /* GraphQL */ `mutation DeleteContextQuestion(
  $input: DeleteContextQuestionInput!
  $condition: ModelContextQuestionConditionInput
) {
  deleteContextQuestion(input: $input, condition: $condition) {
    id
    userProfileId
    questionText
    questionType
    options
    readyForUser
    context
    answer
    answeredAt
    confidenceImpact
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContextQuestionMutationVariables,
  APITypes.DeleteContextQuestionMutation
>;
export const createActivityLog = /* GraphQL */ `mutation CreateActivityLog(
  $input: CreateActivityLogInput!
  $condition: ModelActivityLogConditionInput
) {
  createActivityLog(input: $input, condition: $condition) {
    id
    userProfileId
    type
    relatedId
    title
    description
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateActivityLogMutationVariables,
  APITypes.CreateActivityLogMutation
>;
export const updateActivityLog = /* GraphQL */ `mutation UpdateActivityLog(
  $input: UpdateActivityLogInput!
  $condition: ModelActivityLogConditionInput
) {
  updateActivityLog(input: $input, condition: $condition) {
    id
    userProfileId
    type
    relatedId
    title
    description
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateActivityLogMutationVariables,
  APITypes.UpdateActivityLogMutation
>;
export const deleteActivityLog = /* GraphQL */ `mutation DeleteActivityLog(
  $input: DeleteActivityLogInput!
  $condition: ModelActivityLogConditionInput
) {
  deleteActivityLog(input: $input, condition: $condition) {
    id
    userProfileId
    type
    relatedId
    title
    description
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteActivityLogMutationVariables,
  APITypes.DeleteActivityLogMutation
>;
